module.exports = __webpack_public_path__ + "img/marker.ec363207.png";